import React, { Component } from "react";
import axios from 'axios';
import { MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import {Multiselect} from 'multiselect-react-dropdown';
import "./custom";
import CheckApi from './checkapi';

class WorkAllocation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checking : " datapassing"
        }
    }    
  render() {   
    
        return (
                <section className="workallocation-wrapper" style={{ padding: '40px 0px'}}>
                    <div className="container">                       
                        <CheckApi data={this.state.checking} />  
                        {/* <ul>
                        {this.props.flights.map((flight, index) => {
                            <li>{flight.id}</li>
                        })}
                        </ul> */}
                    </div>
                </section>
        );
    }
}


export default WorkAllocation;
